<ion-app>
  <ng-container *ngIf="appReady(); else appLoading">
    <app-filters></app-filters>
    <app-header-web *ngIf="!disabled() && isWeb"></app-header-web>
    <div
      id="main-content"
      class="h-full menu-content menu-content-overlay"
    >
      <ion-router-outlet></ion-router-outlet>
    </div>

    <app-cookie-banner *ngIf="showCookieBanner()"></app-cookie-banner>
  </ng-container>

  <ng-template #appLoading>
    <div class="min-h-screen w-full bg-[#4FC2EC]"></div>
  </ng-template>


  <!-- Debug Console (global) -->
  <!--<app-debug-console></app-debug-console>-->

</ion-app>
